import { defineStore } from 'pinia'
import type { WishlistItem } from '~/types'

export const useWishlistStore = defineStore('wishlist', () => {
  const items = ref<WishlistItem[]>([])
  const pending = ref(true)
  const catalogService = useCatalogService();

  async function loadWishlist() {
    try {
      pending.value = true

      const {
        data
      } = await catalogService.getWishlist()

      items.value = data
    } catch (error) {
      console.error('Error loading wishlist:', error)
    } finally {
      pending.value = false
    }
  }

  async function addProduct(productId: number) {
    const { data } = await catalogService.addWishlistProduct(productId)
    items.value = data
  }

  async function removeItem(itemId: number) {
    const { data } = await catalogService.removeWishlistItem(itemId)
    items.value = data
  }

  async function clearWishlist() {
    const { data } = await catalogService.clearWishlist()
    items.value = data
  }

  function isWishlisted(productId: number) {
    return items.value.find((item) => item.productId === productId)
  }

  const count = computed(() => items.value.length)
  const productIds = computed(() => items.value.map(item => item.productId))

  return {
    items,
    pending,
    productIds,
    addProduct,
    removeItem,
    isWishlisted,
    clearWishlist,
    loadWishlist,
    count
  }
})
